<template>
  <div v-if="lcbftScore">
    <Alert :type="alertType">
      <template #title v-if="lcbftScore > 70">LCBFT : Alerte importante</template>
      <template #title v-else>LCBFT : Surveillance recommandée</template>
      <span v-if="lcbftRegistryId" class="block mt-1 text-xs">
        Score : {{ lcbftScore }} - ID Registre: {{ lcbftRegistryId }}
      </span>
    </Alert>
  </div>
</template>

<script>
import { Alert } from "@estaly/ui";

export default {
  components: {
    Alert,
  },

  props: ["lcbftScore", "lcbftRegistryId"],

  computed: {
    alertType() {
      return this.lcbftScore > 70 ? "error" : "warning";
    },
  },
};
</script>
